module.exports = __webpack_public_path__ + "static/lights37-66d97728a2faceaae2106674b11ea8ec.jpg";